import { createPinia } from 'pinia'
// 创建pinia
const pinia = createPinia();
export default pinia;
